import React from 'react'
import PropTypes from 'prop-types'
import { KEYCLOAK_REDIRECT_URL_LOGOUT } from 'core/common/constants/env'
import i18n from 'core/common/i18n'
import { Button, Grid } from 'core/components/Core'

const ResultActionArea = props => {
  const { hasLogout, children } = props

  /**
   * Método para remover o tenantId para não conflitar com a próxima sessão.
   */
  const handleLogout = () => {
    sessionStorage.removeItem('maas-tenantId')
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {children}
      </Grid>
      {hasLogout && (
        <Grid item xs={12}>
          <Button href={KEYCLOAK_REDIRECT_URL_LOGOUT} onClick={handleLogout} variant="text">
            {i18n.t('general.logout')}
          </Button>
        </Grid>
      )}
    </Grid>
  )
}

ResultActionArea.propTypes = {
  children: PropTypes.node.isRequired,
  hasLogout: PropTypes.bool,
}

ResultActionArea.defaultProps = {
  hasLogout: false,
}

export default ResultActionArea
